/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.GameObjects.Components
 */

module.exports = {

    Alpha: require('./Alpha'),
    Animation: require('./Animation'),
    BlendMode: require('./BlendMode'),
    ComputedSize: require('./ComputedSize'),
    Depth: require('./Depth'),
    Flip: require('./Flip'),
    GetBounds: require('./GetBounds'),
    Origin: require('./Origin'),
    Pipeline: require('./Pipeline'),
    ScaleMode: require('./ScaleMode'),
    ScrollFactor: require('./ScrollFactor'),
    Size: require('./Size'),
    Texture: require('./Texture'),
    Tint: require('./Tint'),
    ToJSON: require('./ToJSON'),
    Transform: require('./Transform'),
    TransformMatrix: require('./TransformMatrix'),
    Visible: require('./Visible')

};



//////////////////
// WEBPACK FOOTER
// ./gameobjects/components/index.js
// module id = 14
// module chunks = 0